(ns client-portal.client.router
  (:require [shared.core.router :as router]
            [client-portal.client.routes :as routes]
            [clojure.string :as s]
            [reitit.core :as reitit]
            [reitit.frontend :as rfe]
            [shared.core.reactive :as re]))

(defonce app-router*
         (atom (rfe/router (mapv (fn [[route-k {:keys [uri]}]] [uri route-k]) routes/routes))))

(defn route-match-by-name
  ([route-name]
   (route-match-by-name route-name {}))
  ([route-name path-params]
   (router/route-match-by-name @app-router* route-name path-params)))

(defn route-details->href [route-k path-params query-params]
  (-> (route-match-by-name route-k (or path-params {}))
      (reitit/match->path (or query-params {}))))

(defn route->path
  "URI path for `route-name` (with optional `path-params`), or nil when it isn't a known route."
  ([route-name] (route->path route-name {}))
  ([route-name path-params]
   (some-> (route-match-by-name route-name (or path-params {}))
           (reitit/match->path))))

(defn path->route-name
  [path]
  (keyword (cond-> path (s/starts-with? path "/") (subs 1))))

(defn register-routes!
  "Registers any `route-paths` (strings) the router doesn't already resolve, keyed by a
   keyword derived from each path, then restarts history once so navigation resolves them."
  [route-paths]
  (let [new-paths (remove #(reitit/match-by-path @app-router* %) route-paths)]
    (when (not-empty new-paths)
      (swap! app-router*
             (fn [app-router]
               (reduce (fn [app-router path]
                         (router/add-route app-router [path {:name (path->route-name path)}]))
                       app-router
                       new-paths)))
      (router/start! @app-router*))))

(defn reset-routes! []
  (reset! app-router* (rfe/router (mapv (fn [[route-k {:keys [uri]}]] [uri route-k]) routes/routes)))
  (router/start! @app-router*))

(defn start! []
  (router/start! @app-router*))